import React from 'react';
import {
  Card, Col, Row, Tabs,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import EtaReportSection from './Components/EtaReportSection';
import NoAccessGrantedComponent from '../../../components/NoAccessGrantedComponent';
import { getSelectedCompany, isFeatureEnabled } from '../../../store/selectors';
import { FeatureToggle } from '../../../store/actions';

const { TabPane } = Tabs;

const Reports = () => {
  const { t } = useTranslation();
  const selectedCompany = useSelector(getSelectedCompany);
  const reportsTabEnabled = useSelector(isFeatureEnabled(FeatureToggle.ETA_REPORTS_ENABLED));
  const displayContent = selectedCompany && reportsTabEnabled;

  return (
    <>
      <BreadcrumbsItem to="/orders">{t('BREADCRUMB.MONITORINGS')}</BreadcrumbsItem>

      <BreadcrumbsItem to="/orders/reports">{t('BREADCRUMB.REPORTS')}</BreadcrumbsItem>
      {!displayContent ? (
        <NoAccessGrantedComponent />
      ) : (
        <Tabs defaultActiveKey="1">
          <TabPane tab={t('REPORTS.ETA_REPORT_TAB_TITLE')} key="1">
            <Row justify="space-between">
              <Col span={12}>
                <Card>
                  <EtaReportSection />
                </Card>
              </Col>
            </Row>
          </TabPane>
        </Tabs>
      )}
    </>
  );
};

export default Reports;
